import { CREATE_ERROR, DELETE_ERROR, CREATE_FATAL_ERROR, DELETE_FATAL_ERROR } from './mutation-types';

export function createError({ commit }, error) {
    const errors = [];

    if (error.response.status === 422) {
        const fields = error.response.data.error.fields;

        if (fields) {
            fields.forEach((field, fieldIndex) => {
                field.messages.forEach((message, messageIndex) => {
                    errors.push(message);
                });
            });
        } else {
            const message = error.response.data.error.message;

            if (message) {
                errors.push(message);
            }
        }
    } else if (error.response.status === 500) {
        errors.push(error.response.data.error.message);
    } else {
        errors.push('An error occured, please refresh and try again');
    }

    commit(CREATE_ERROR, errors);
}

export function deleteError({ commit }) {
    commit(DELETE_ERROR);
}

export function createFatalError({ commit }) {
    commit(CREATE_FATAL_ERROR);
}

export function deleteFatalError({ commit }) {
    commit(DELETE_FATAL_ERROR);
}



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/errors/actions.js